import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/app-gallery-small.svg")